/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Economics_Management24Inputs */

const en__field_enum_icsrm_economics_management24 = /** @type {(inputs: _Field_Enum_Icsrm_Economics_Management24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economics & Management`)
};

const de__field_enum_icsrm_economics_management24 = /** @type {(inputs: _Field_Enum_Icsrm_Economics_Management24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirtschaft & Management`)
};

/**
* | output |
* | --- |
* | "Economics & Management" |
*
* @param {_Field_Enum_Icsrm_Economics_Management24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_economics_management24 = /** @type {((inputs?: _Field_Enum_Icsrm_Economics_Management24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Economics_Management24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_economics_management24(inputs)
	return de__field_enum_icsrm_economics_management24(inputs)
});
export { _field_enum_icsrm_economics_management24 as "_field_enum_ICSRM_ECONOMICS_MANAGEMENT" }